import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/700.css";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router";
import { AppRoutes } from "./AppRoutes.tsx";
import { CookiesProvider } from "react-cookie";
import { ThemeContextProvider } from "./contexts/theme/ThemeContextProvider.tsx";
import { ErrorContextProvider } from "./contexts/error/ErrorContextProvider.tsx";

console.log("React version:", React.version);
console.log("React internals:", React);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeContextProvider>
      <BrowserRouter>
        <CookiesProvider
          defaultSetOptions={{
            httpOnly: false,
            secure: true,
            path: "/",
            sameSite: "none",
            partitioned: true,
          }}
        >
          <ErrorContextProvider>
            <AppRoutes />
          </ErrorContextProvider>
        </CookiesProvider>
      </BrowserRouter>
    </ThemeContextProvider>
  </StrictMode>,
);
